import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('QuestionsOptionsStructure')
export class QuestionsOptionsStructure {
  @JsonProperty('active', Boolean)
  active: boolean = undefined;
  @JsonProperty('id', Number)
  id: number = undefined;
  @JsonProperty('value', String)
  value: string = undefined;

  selected: boolean = false;
}

@JsonObject('QuestionsStructure')
export class QuestionsStructure {
  @JsonProperty('id', Number)
  id: number = undefined;
  @JsonProperty('question', String)
  question: string = undefined;
  @JsonProperty('value', Number)
  value: number = undefined;
  @JsonProperty('idQuestionType', Number, true)
  idQuestionType: number = undefined;
  @JsonProperty('valueText', String, true)
  valueText: string = undefined;
  @JsonProperty('questionListOptions', [QuestionsOptionsStructure], true)
  questionListOptions: Array<QuestionsOptionsStructure> = [];
}

@JsonObject('FocusesStructure')
export class FocusesStructure {
  @JsonProperty('focus', String)
  focus: string = undefined;
  @JsonProperty('message', String, true)
  message: string = undefined;
  @JsonProperty('image', String, true)
  image: string = undefined;
  @JsonProperty('scope', String, true)
  scope: string = undefined;
  @JsonProperty('questions', [QuestionsStructure])
  questions: Array<QuestionsStructure> = undefined;
}

@JsonObject('PollStructure')
export class PollStructure {
  @JsonProperty('pollId', Number)
  pollId: number = undefined;
  @JsonProperty('instanceId', String)
  instanceId: string = undefined;
  @JsonProperty('focuses', [FocusesStructure])
  focuses: FocusesStructure[] = [];
}
